import {
  AskableAsset,
  AskableAssetFormData,
  AskableAssetResults,
  AskableAssetSearchParams,
  AskableImageParams,
} from "types";

import API from "api/client";
import { downloadFileWithoutPopup } from "utils/download/downloadFile";
import { envConfig } from "config";

const { askablesAPI } = envConfig;

const getAskableImage = (id: number, params: AskableImageParams): Promise<Blob> => {
  return API.get(`${askablesAPI}${id}/image`, {
    params,
    responseType: "blob", // tells Axios to give us a Blob
  }).then((res) => res.data);
};

const getAskableAssets = (params: AskableAssetSearchParams): Promise<AskableAssetResults> => {
  return API.get<AskableAssetResults>(`${askablesAPI}${params.id}/assets`, { params }).then((res) => res.data);
};

const getAskableAsset = (id: number): Promise<AskableAsset> => {
  return API.get<AskableAsset>(`${askablesAPI}assets/${id}`).then((res) => res.data);
};

const createAskableAsset = (id: number, req: AskableAssetFormData): Promise<AskableAsset> => {
  return API.post(`${askablesAPI}${id}/assets`, req).then((res) => res.data);
};

const deleteAskableAsset = (id: number): Promise<void> => {
  return API.delete(`${askablesAPI}assets/${id}`).then((res) => res.data);
};

const downloadAskableAsset = async (id: number): Promise<void> => {
  const { data } = await API.get(`${askablesAPI}assets/${id}/download`);
  downloadFileWithoutPopup(data);
};

const copyAskableAsset = async (id: number): Promise<string> => {
  return API.get(`${askablesAPI}assets/${id}/copy`).then((x) => x.data);
};

export default {
  getImage: getAskableImage,
  getAsset: getAskableAsset,
  createAsset: createAskableAsset,
  copyAsset: copyAskableAsset,
  deleteAsset: deleteAskableAsset,
  downloadAsset: downloadAskableAsset,
  listAssets: getAskableAssets,
};
